import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import { CheckinProvider } from "./context/CheckinContext";
import Home from "./pages/Home";
import ParentPhone from "./pages/ParentPhone";
import ParentRegister from "./pages/ParentRegister";
import SelectChildren from "./pages/SelectChildren";
import Confirmation from "./pages/Confirmation";
import HostLogin from "./pages/HostLogin";
import HostDashboard from "./pages/HostDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import BirthdayRequest from "./pages/BirthdayRequest";
import QRLanding from "./pages/QRLanding";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <CheckinProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/parent/phone" element={<ParentPhone />} />
                <Route path="/parent/register" element={<ParentRegister />} />
                <Route path="/parent/select" element={<SelectChildren />} />
                <Route path="/parent/confirmation" element={<Confirmation />} />
                <Route path="/host" element={<HostLogin />} />
                <Route path="/host/login" element={<HostLogin />} />
                <Route path="/host/dashboard" element={<HostDashboard />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/birthday" element={<BirthdayRequest />} />
                <Route path="/qr" element={<QRLanding />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors style={{ "--width": "min(356px, calc(100vw - 2rem))" }} />
          </CheckinProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
